export enum ItaProdPolicy {
    Read = 'Read',
    Write = 'Write',
    Admin = 'Admin',
    NoAccess = 'NoAccess'
}